<template>
  <transition name="otips">
    <div class="q-tips" v-if="visible" :class='type === "success" ? "oSuccess" : ""'>
      <div class="messageW" v-if="type==='info'"><p class="messageC">{{message}}</p></div>
      <div class="successWrapper" v-if='type==="success"'>
        <img class="simg" src="./images/success.png" alt="">
        <div class="oclose" @click='closeSuccess'></div>
      </div>
      <div class="loadingWrapper" v-if="type==='loading'">
        <i class="loadingW"></i>
        <p class="loadFont">{{message}}</p>
      </div>
    </div>
  </transition>
</template>
<script>
const typeMap = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error'
};
/**
 * this.$tips.del();
 * **/
import {isAndroid} from '@/libs/utils'
export default {
  name: 'QTips',
  props: [],
  data () {
    return {
        visible: false,
        message: '',
        duration: 3000,
        type: 'info',
        iconClass: '',
        timer: null,
        canClick: false,
        // clickNumber:0    //当前点击次数
    }
  },
  computed: {
  },
  methods: {
    open(info) {

      console.log(info);

      this.visible = true;
      this.type = info.type;
      this.message = info.content;
      this.duration = info.duration*1000 + 400;
      this.canClick = info.canClick;
      if (!this.canClick) {
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
          this.visible = false;
        }, this.duration);
      }
    },
    exitPage() {
      if (!isAndroid()) {
        try {
          webkit.messageHandlers.back.postMessage({});
        } catch (error) {
          console.log('back to login ios', error)
        }
      } else {
        try {
          // android exit page
          window.androidApi.backCalls();
        } catch (error) {
          console.log('back to login android', error)
        }
      }
    },
    closeSuccess() {
      console.log('跳转到移动办公主页');
      this.exitPage();

      // if(!this.clickNumber){
      // console.log('无效点击');
      // // this.clickNumber++
    	// 			setTimeout(()=>{
      //   this.clickNumber++
			// 	},2000)
      // }else{
      // console.log('跳转到移动办公主页');
      // this.exitPage();
      // }
    },
    closeSelf() {
      this.visible = false;
    }
  },
  mounted() {
  }
}
</script>
<style lang="scss" scoped>
@import '~@/common/scss/const.scss';
@import '~@/common/scss/mixin.scss';

.q-tips {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0px;
  right: 0px;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background: transparent;
  &.otips-enter-active, &.otips-leave-active {
    transition: opacity .4s linear;
  }
  &.otips-enter, &.otips-leave-to {
    opacity: 0;
  }
  .messageW {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    transform-origin: center;
    color: #ffffff;
    z-index: 1003;
    border: none;
    border-radius: 4px;
    background:rgba(0, 0, 0, 0.6);
    padding: 8px 10px;
    max-width: 90%;
    font-size: 0;
    .messageC {
      font-size: 14px;
      text-align: center;
    }
  }

  &.oSuccess {
    background: rgba(0, 0, 0, 0.6);
    .successWrapper {
      width: pxToRem(286);
      position: absolute;
      top: 20%;
      left: 50%;
      transform: translate(-50%, -10%);
      -webkit-transform: translate(-50%, -10%);
      transform-origin: center;
      .simg {
        width: 100%;
      }
      .oclose {
        position: absolute;
        width: pxToRem(40);
        height: pxToRem(40);
        background:url('./images/close.png') no-repeat center center;
        background-size: 100% 100%;
        background-origin: center center;
        left: 50%;
        transform: translateX(-50%);
        bottom: pxToRem(-65);
      }
    }
  }
  .loadingWrapper {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0.6);
    border-radius: 4px;
    @include display-flex;
    @include flex-direction(column);
    @include justify-content(center);
    @include align-items(center);
    padding: 10px 20px;
    max-width: 90%;
    .loadingW {
      display: block;
      width: 20px;
      height: 20px;
      background: url('./images/loading.svg') no-repeat center center;
      border-radius: 50%;
      background-size: 100% 100%;
      animation: rotating 2.2s linear infinite;
    }
    .loadFont {
      display: inline-block;
      text-align: center;
      font-size: 14px;
      color: #ffffff;
      margin-top: 8px;
      font-family:PingFangSC-Regular;
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      -ms-text-overflow: ellipsis;
      letter-spacing: 1px;
    }
  }
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loadingk {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/QTips/src/QTips.vue